module.exports = __webpack_public_path__ + "static/media/aiLoading.b3df88e7.gif";